<div
  class="icon-wrapper"
  [ngClass]="name"
  [inlineSVG]="'assets/icons/' + name + '.svg'"
  [removeSVGAttributes]="['width', 'height']"
></div>
